import { PARTNER_COOKIE, setPartnerCookie } from '@artic/ui/lib/auth-cookies'

/**
 * Recoil effect that syncs the partner atom to the `artic_partner` cookie.
 * Reads are still from localStorage (via localStorageEffect); this only writes
 * so other subdomains (quality, etc.) can read the partner selection.
 *
 * On initialization, reads the persisted value from localStorage and writes
 * the cookie immediately so the cookie is available on first page load.
 */
const partnerCookieEffect =
  () =>
  ({ onSet }: { onSet: any }) => {
    const domain = import.meta.env.VITE_AUTH_COOKIE_DOMAIN || undefined

    // Sync cookie on initialization from localStorage-persisted value
    try {
      const stored = localStorage.getItem('current_partner')
      if (stored) {
        const parsed = JSON.parse(stored)
        if (parsed?.partner_key) {
          setPartnerCookie(parsed.partner_key, { domain })
        }
      }
    } catch {
      // Best effort — localStorage or JSON parse may fail
    }

    onSet((newValue: any, _: any, isReset: any) => {
      if (isReset || !newValue || !newValue.partner_key) {
        // Clear by setting max-age=0
        document.cookie = `${PARTNER_COOKIE}=; path=/; max-age=0; SameSite=Lax${domain ? `; domain=${domain}` : ''}`
      } else {
        setPartnerCookie(newValue.partner_key, { domain })
      }
    })
  }

export default partnerCookieEffect
